import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../components/files/attachmentFilePreview.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../utils/Draft.ext.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ContractorNote59o6kpmrrw5h as ContractorNote } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_message3j75qq96irblw as get_message } from '../../../../../crowpay-shared/com/crowpay/ContractorNoteFields.mjs';
import { lensPath2kkrykycsgvs9 as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../extensions/ProjectAttachment.ext.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  titleWithClose1c8wgipb8qrii as titleWithClose,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from '../components/files/fileManager.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().gfg_1);
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.wi8_1 = p0;
      }
      uao($completion) {
        return this.wi8_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xi8_1.hh0_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return it.j5p(VOID, VOID, VOID, VOID, tmp_0);
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = modify($this.yi8_1.fh0_1, CreateOrEditNote$render$slambda$slambda_0($this.yi8_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = $this.yi8_1.eh0_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp_0 = tmp0_safe_receiver($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$0 = tmp_1;
  var tmp_2 = pushChanges($this.yi8_1.fh0_1, tmp$ret$0.bfw_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  get_dialogStack().pgd();
  return Unit_instance;
}
var CreateOrEditNote$render$slambda$slambdaClass;
function CreateOrEditNote$render$slambda$slambda() {
  if (CreateOrEditNote$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.xi8_1 = this$0;
      }
      zi8(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.zi8(p1 instanceof ContractorNote() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditNote$render$slambda$slambdaClass = $;
  }
  return CreateOrEditNote$render$slambda$slambdaClass;
}
function CreateOrEditNote$render$slambda$slambda_0(this$0) {
  var i = new (CreateOrEditNote$render$slambda$slambda())(this$0);
  var l = (it, $completion) => i.zi8(it, $completion);
  l.$arity = 1;
  return l;
}
var CreateOrEditNote$render$slambdaClass;
function CreateOrEditNote$render$slambda() {
  if (CreateOrEditNote$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditNote$render$slambdaClass = $;
  }
  return CreateOrEditNote$render$slambdaClass;
}
function CreateOrEditNote$render$slambda_0() {
  var i = new (CreateOrEditNote$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function CreateOrEditNote$render$lambda() {
  get_dialogStack().pgd();
  return Unit_instance;
}
var CreateOrEditNote$render$lambda$slambdaClass;
function CreateOrEditNote$render$lambda$slambda() {
  if (CreateOrEditNote$render$lambda$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditNote$render$lambda$slambdaClass = $;
  }
  return CreateOrEditNote$render$lambda$slambdaClass;
}
function CreateOrEditNote$render$lambda$slambda_0() {
  var i = new (CreateOrEditNote$render$lambda$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var CreateOrEditNote$render$slambdaClass_0;
function CreateOrEditNote$render$slambda_1() {
  if (CreateOrEditNote$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.yi8_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditNote$render$slambdaClass_0 = $;
  }
  return CreateOrEditNote$render$slambdaClass_0;
}
function CreateOrEditNote$render$slambda_2(this$0) {
  var i = new (CreateOrEditNote$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateOrEditNote$render$slambdaClass_1;
function CreateOrEditNote$render$slambda_3() {
  if (CreateOrEditNote$render$slambdaClass_1 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditNote$render$slambdaClass_1 = $;
  }
  return CreateOrEditNote$render$slambdaClass_1;
}
function CreateOrEditNote$render$slambda_4() {
  var i = new (CreateOrEditNote$render$slambda_3())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateOrEditNoteClass;
function CreateOrEditNote() {
  if (CreateOrEditNoteClass === VOID) {
    class $ {
      static ai9(project, lineItem, note, subHeader, beforeSubmit) {
        subHeader = subHeader === VOID ? null : subHeader;
        beforeSubmit = beforeSubmit === VOID ? null : beforeSubmit;
        var $this = createThis(this);
        $this.ch0_1 = note;
        $this.dh0_1 = subHeader;
        $this.eh0_1 = beforeSubmit;
        var tmp = $this;
        var tmp0_elvis_lhs = $this.ch0_1;
        tmp.fh0_1 = Draft(tmp0_elvis_lhs == null ? new (ContractorNote())(VOID, project, lineItem, '') : tmp0_elvis_lhs);
        var tmp_0 = $this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = $this.fh0_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_1 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
        var tmp$ret$0 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$0);
        var tmp$ret$2 = get_message(it);
        tmp_0.gh0_1 = lensPath(this_0, tmp$ret$2);
        var tmp_2 = $this;
        var tmp0_safe_receiver = $this.ch0_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f5p_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toFileData(tmp1_safe_receiver);
        tmp_2.hh0_1 = Signal().hak(tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs);
        return $this;
      }
      static vh1(note, subHeader, beforeSubmit) {
        beforeSubmit = beforeSubmit === VOID ? null : beforeSubmit;
        return this.ai9(note.c5p_1, note.d5p_1, note, subHeader, beforeSubmit);
      }
      static ih0(project, lineItem, subHeader, beforeSubmit) {
        beforeSubmit = beforeSubmit === VOID ? null : beforeSubmit;
        return this.ai9(project, lineItem, null, subHeader, beforeSubmit);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(CreateOrEditNote$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        view.bb9(get_AppDimensions().yg1_1);
        var tmp = view.kbb(view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40))), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        var tmp_0 = this.ch0_1 == null ? 'New Note' : 'Edit Note';
        titleWithClose(view_1, tmp_0, CreateOrEditNote$render$lambda);
        var tmp0_elvis_lhs_2 = this.dh0_1;
        body(view_1, tmp0_elvis_lhs_2 == null ? 'Add notes, pictures, or files to show progress for the client. Notes can be added and modified until the work item is accepted.' : tmp0_elvis_lhs_2);
        label2(view_1, 'Note', VOID, ($this$label2) => {
          var tmp0_width = get_rem(40);
          var tmp1_minHeight = get_rem(10);
          var tmp = sizeConstraints($this$label2, VOID, VOID, tmp1_minHeight, VOID, VOID, tmp0_width);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = $this$label2.jbb(FieldSemantic_getInstance());
          var tmp_0 = $this$label2.kbb(tmp, tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextArea())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zah(view.scl_1, this.gh0_1);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp_0, view);
        });
        label2(view_1, 'Files', VOID, ($this$label2) => {
          var tmp = sizeConstraints($this$label2, VOID, VOID, VOID, VOID, VOID, get_rem(40));
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$4 = $this$label2.jbb(FieldSemantic_getInstance());
          var tmp_0 = $this$label2.kbb(tmp, tmp$ret$4);
          return $this$label2.lbb(tmp_0, fileManager($this$label2, this.hh0_1, 'No Files Uploaded', VOID, VOID, CreateOrEditNote$render$lambda$slambda_0()));
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.bb9(get_AppDimensions().kg2_1);
        var tmp_1 = get_primaryButton(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_3, view_3);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = Button$_get_enabled_$ref_61t7nx(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var tmp;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_1 = $this$reactiveScope.daj(this.gh0_1);
          if (!isBlank(this_1)) {
            tmp = true;
          } else {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp = !$this$reactiveScope.daj(this.hh0_1).i1();
          }
          var tmp$ret$7 = tmp;
          this_0.set(tmp$ret$7);
          return Unit_instance;
        });
        specCenteredText(view_3, this.ch0_1 == null ? 'Create Note' : 'Save Changes');
        onClick(view_3, VOID, VOID, CreateOrEditNote$render$slambda_2(this));
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_1, view_3);
        var tmp_4 = get_textButton(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_2.pc());
        var tmp0_elvis_lhs_5 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
        view_2.gbb(p_4, view_4);
        specCenteredText(view_4, 'Go Back');
        onClick(view_4, VOID, VOID, CreateOrEditNote$render$slambda_4());
        view_2.hbb(p_4, view_4);
        view_2.lbb(tmp_4, view_4);
        view_1.hbb(p_2, view_2);
        view_0.hbb(p_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'CreateOrEditNote', VOID, VOID, [Page()]);
    CreateOrEditNoteClass = $;
  }
  return CreateOrEditNoteClass;
}
//region block: exports
export {
  CreateOrEditNote as CreateOrEditNote2axvnom01lmg9,
};
//endregion

//# sourceMappingURL=CreateOrEditNote.mjs.map
